import { Typography } from "@povio/ui";

import { DateUtils } from "@/util/date.utils";

export const DatePeriodSegment = ({
  period,
  className,
}: {
  period: { start_date: string | null; end_date: string | null } | null;
  className?: string;
}) => {
  if (!period) return null;

  const startDate = period.start_date ? DateUtils.getLocalizedDate(period.start_date, "MMM yyyy") : "";
  const endDate = period.end_date ? DateUtils.getLocalizedDate(period.end_date, "MMM yyyy") : "";

  return (
    <Typography
      as="span"
      size="label-4"
      className={className}
    >
      {startDate} {startDate && endDate ? " - " : ""} {endDate}
    </Typography>
  );
};
